import type {
  PodTaskSourceInfo,
  PodTaskSourceType,
} from "@app/types/project_task";

const CONVERSATION_PATH_RE = /\/w\/[^/]+\/conversation\/([^/?#]+)/;
const NOTION_HOSTS = ["notion.so", "notion.site", "app.notion.com"];

function inferSourceTypeFromHostname(hostname: string): PodTaskSourceType {
  if (hostname.includes("slack.com")) {
    return "slack";
  }
  if (hostname.includes("github.com")) {
    return "github";
  }
  if (
    NOTION_HOSTS.some(
      (host) => hostname === host || hostname.endsWith(`.${host}`)
    )
  ) {
    return "notion";
  }
  if (hostname.includes("atlassian.net") || hostname.includes("confluence")) {
    return "confluence";
  }
  if (
    hostname.includes("microsoft.com") ||
    hostname.includes("sharepoint.com") ||
    hostname.includes("office.com")
  ) {
    return "microsoft";
  }
  if (hostname.includes("google.com")) {
    return "gdrive";
  }
  return "project_knowledge";
}

export function inferProjectTaskSourceFromUrl({
  url,
  title,
}: {
  url: string;
  title: string;
}): PodTaskSourceInfo {
  try {
    const parsed = new URL(url);
    const conversationMatch = parsed.pathname.match(CONVERSATION_PATH_RE);
    if (conversationMatch) {
      return {
        sourceType: "project_conversation",
        sourceId: conversationMatch[1]!,
        sourceTitle: title,
        sourceUrl: url,
      };
    }

    return {
      sourceType: inferSourceTypeFromHostname(parsed.hostname.toLowerCase()),
      sourceId: url,
      sourceTitle: title,
      sourceUrl: url,
    };
  } catch {
    return {
      sourceType: "project_knowledge",
      sourceId: url,
      sourceTitle: title,
      sourceUrl: url,
    };
  }
}
